import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useDirectInterlines } from '../../hooks';
import type { DirectInterline, DirectInterlineFilters } from '../../models';

export interface DirectInterlineFieldProps extends Omit<SelectProps<DirectInterline>, 'options'> {
  defaultFilters?: Partial<DirectInterlineFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<DirectInterline>['errorMessage'];
  isInvalid?: boolean;
}

export const DirectInterlineField: React.FC<DirectInterlineFieldProps> = ({
  defaultFilters,
  label,
  ...otherFieldProps
}) => {
  const { data, isLoading, updateFilters } = useDirectInterlines(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
      isLoading={isLoading}
    />
  );
};
